<template>
  <div class="CommandUserCard">
    <div class="titleBox">
      <div class="imgBox">
        <img src="@/assets/images/msgt/titleIcon.png" />
      </div>
      <p>智慧能源运维指挥体系</p>
    </div>
    <div class="contentBox">
      <ul class="left">
        <li v-for="(v,i) in leftUser"
          :key="i">
          <p @click="v.showPhone = !v.showPhone"
            style="cursor: pointer;"><i class="iconfont icon-a-tubiaodianhua"></i> {{v.name}} </p>
          <p>{{v.showPhone?v.phone:''}}</p>
        </li>
      </ul>
      <ul class="content">
        <li v-for="(v,i) in contentUser"
          :key="i">
          <p @click="v.showPhone = !v.showPhone"
            style="cursor: pointer;"><i class="iconfont icon-a-tubiaodianhua"></i> {{v.name}} </p>
          <p>{{v.showPhone?v.phone:''}}</p>
        </li>
      </ul>
      <ul class="right">
        <li v-for="(v,i) in rightUser"
          :key="i">
          <p @click="v.showPhone = !v.showPhone"
            style="cursor: pointer;"><i class="iconfont icon-a-tubiaodianhua"></i> {{v.name}} </p>
          <p>{{v.showPhone?v.phone:''}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftUser: [
        { name: "李梦", phone: "139-8345-7017", showPhone: false },
        { name: "柳宗元", phone: "178-1764-6095", showPhone: false },
      ],
      rightUser: [
        { name: "朱小梦", phone: "136-1945-8897", showPhone: false },
        { name: "黎辉", phone: "139-7182-9999", showPhone: false },
      ],
      contentUser: [
        { name: "李衍", phone: "139-2450-5410", showPhone: false },
        { name: "唐清晖", phone: "135-6599-7236", showPhone: false },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.CommandUserCard {
  width: 90%;
  height: 260px;
  margin: 0 auto;
  .titleBox {
    width: 100%;
    height: 44px;
    background: url("~@/assets/images/msgt/userTitle.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    @include setFlexStart;
    .imgBox {
      margin: 0 6px 0 30px;
    }
    p {
      color: #dfe6ee;
      font-weight: bold;
      font-size: 16px;
    }
  }
  .contentBox {
    width: 100%;
    height: 216px;
    background: url("~@/assets/images/msgt/userContent.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    @include setFlexCenter;
    .left,
    .right {
      width: calc((100% - 180px) / 2);
      height: 180px;
      @include setFlexColumn;
      justify-content: space-between;
      color: #dfe6ee;
      li {
        // width: 113px;
        height: 57px;
        background: url("~@/assets/images/msgt/phone.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        @include setFlexColumn;
        justify-content: center;
        text-align: center;
        p:first-child {
          color: #d2dbec;
          font-size: 15px;
        }
      }
    }
    .content {
      width: 135px;
      height: 135px;
      margin: 0 6px;
      background: url("~@/assets/images/msgt/round.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      @include setFlexColumn;
      justify-content: center;
      align-items: center;
      color: #fff;
      li {
        @include setFlexColumn;
        justify-content: center;
        text-align: center;
        margin-bottom: 3px;
        p:first-child {
          color: #39e4ea;
          font-weight: 500;
          font-size: 15px;
        }
      }
    }
  }
}
</style>